import { render, staticRenderFns } from "./CloseDialogButton.vue?vue&type=template&id=1268789a&scoped=true&"
import script from "./CloseDialogButton.vue?vue&type=script&lang=js&"
export * from "./CloseDialogButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268789a",
  null
  
)

export default component.exports